import mountVues from "@galaxy/modules/Core/resources/js/mountVues";

common.View.create('crud::form.Postback', {

    /**
     * Called when DOM is ready.
     */
    onDOMLoad()
    {
        this.initPostback();
    },

    /**
     * Initializes the GUI.
     */
    initPostback()
    {
        // Get input
        let $input = $('html, body').find('[name'+ (this.element.data('match') || '') + '="' + this.element.data('input') + '"]'),
            $postbackGroups = this.element.find('.postbackGroup');

        // Find input that will activate the postback
        $input
            // On change event of that input
            .on('change', (event) =>
            {
                // Show specific postback group(s) based on input
                this.showPostbackGroup($postbackGroups, event.currentTarget);
            })
            .end();

        // Show specific postback group(s) based on input
        this.showPostbackGroup($postbackGroups, $input);
    },

    showPostbackGroup($postbackGroups, target)
    {
        // Loop element postback groups
        $postbackGroups.each((key, value) =>
        {
            // Get postback values
            let postbackValues = $(value).find('> :first');

            // Remove value wrapper so you don't have 'required' not focusable issues
            if (postbackValues.is('div')) {
                postbackValues.remove();
            }

            // Hide group
            $(value).hide();

            // Is just a postback where you only show the item if an option is selected
            // Or show this specific element?
            let inputVal = this.getCurrentInputValue(target);

            if ((inputVal && $(value).is('[data-value*="inputSelect"]')) ||
                (!inputVal && $(value).is('[data-value*="inputNotSelect"]')) ||
                this.groupContainsValue(value, inputVal)
            ) {
                // Get template.
                let template = $(value).find('noscript').text(),
                    templateWrapper = document.createElement('div');

                // Remove script wrapper?
                if (template.trim().startsWith('<script type="text/html">'))
                    template = template.trim().substr('<script type="text/html">'.length, template.length - '</script>'.length);

                // Wrap in div
                templateWrapper = $(templateWrapper).html(template);

                // Add wrapper template and show div
                $(value)
                    .prepend(templateWrapper)
                    .show();
            }
        });

        // Re init vue
        mountVues(this.element);

        // Run trigger
        this.element.trigger('crud::form-postback:change');

        // Re init view
        common.View.reinit();
    },

    getCurrentInputValue(input)
    {
        // Is checkable?
        if ($.inArray($(input).attr('type'), ['checkbox', 'radio', 'switch']) !== -1) {
            return $('input[name="' + $(input).attr('name') + '"]:checked').val();
        }

        // Is switch input?
        if ($(input).parents('[class*="crud::form-inputs"]').is('[class*="Switch"]')) {
            return $(input).prop('checked');
        }

        return $(input).val();
    },

    groupContainsValue(value, inputVal)
    {
        // Add underscores when inputVal is numeric, otherwise the keys will be reset by PHP.
        inputVal = !isNaN(inputVal) ? '__'+inputVal : inputVal;

        // Contains value?
        if( $(value).is('[data-value="' + inputVal + '"]') ) {
            return true;
        }

        // Has negative value
        if( this.element.find('.postbackGroup[data-value^="isNot"]').length && !$(value).is('[data-value="isNot' + inputVal + '"]') ) {
            return true;
        }
    }

});
